import * as S from './index.style'
import { DadosDetalhamentoProjeto } from 'models/Viabilidade/DadosDetalhamentoProjeto'
import Button from '@material-ui/core/Button'
import { Add } from '@styled-icons/material-rounded/Add'
import Table from '@material-ui/core/Table'
import TableRow from '@material-ui/core/TableRow'
import TableHead from '@material-ui/core/TableHead'
import TableCell from '@material-ui/core/TableCell'
import TableBody from '@material-ui/core/TableBody'
import { DadosTipologia, dadosTipologiaValorDefault } from 'models/Viabilidade/Tipologia'
import { useState } from 'react'
import Dialog from '@material-ui/core/Dialog'
import { Edit } from '@styled-icons/material-rounded/Edit'
import { Delete } from '@styled-icons/material-rounded/Delete'
import { ContentCopy } from '@styled-icons/material-outlined/ContentCopy'
import IconButton from '@material-ui/core/IconButton'
import NumberFormat from 'react-number-format'
import NovaTipologia from './NovaTipologia'
import theme from 'styles/theme'
import TableContainer from '@material-ui/core/TableContainer'

const Tipologias: React.FC<{
  dadosDetalhamentoProjeto: DadosDetalhamentoProjeto
  dadosTipologiaHandler: (novoValor: DadosTipologia[]) => void
}> = ({ dadosDetalhamentoProjeto, dadosTipologiaHandler }) => {
  const [dialogAberto, setDialogAberto] = useState(false)
  const [dadosTipologias, setDadosTipologia] = useState(dadosDetalhamentoProjeto.tipologias)
  const [tipologiaEdicao, setTipologiaEdicao] = useState(dadosTipologiaValorDefault)
  const [indiceEdicao, setIndiceEdicao] = useState(0)

  const valorFormatado = (valor: string | number, scala = 2, prefix = '', suffix = '') => {
    const valorConvertido = parseFloat(valor.toString()).toLocaleString('pt-BR')
    return (
      <NumberFormat
        value={valorConvertido}
        decimalScale={scala}
        thousandSeparator="."
        decimalSeparator=","
        displayType={'text'}
        defaultValue="-"
        prefix={prefix}
        suffix={suffix}
        fixedDecimalScale
      />
    )
  }

  const fecharDialog = () => {
    setDialogAberto(false)
  }

  const abrirDialog = () => {
    setTipologiaEdicao(dadosTipologiaValorDefault)
    setDialogAberto(true)
  }

  const adicionarNovaTipologiaHandler = (novoValor: DadosTipologia) => {
    const novosDadosTipologia = [...dadosTipologias, novoValor]
    setDialogAberto(false)
    setDadosTipologia(novosDadosTipologia)
    dadosTipologiaHandler(novosDadosTipologia)
  }

  const editarTipologiaDialogHandler = (novoValor: DadosTipologia, indiceEdicao: number) => {
    const novosDadosTipologia = dadosTipologias.map((value, index) => {
      if (index === indiceEdicao) {
        value = novoValor
      }
      return value
    })
    setDialogAberto(false)
    setDadosTipologia(novosDadosTipologia)
    dadosTipologiaHandler(novosDadosTipologia)
  }

  const deletarTipologiaHandler = (indiceRemover: number) => {
    const novosDadosTipologia = dadosTipologias.filter((_value, index) => index != indiceRemover)
    setDadosTipologia(novosDadosTipologia)
    dadosTipologiaHandler(novosDadosTipologia)
  }

  const editarTipologiaHandler = (index: number) => {
    const tipologiaParaEditar = dadosTipologias[index]
    setIndiceEdicao(index)
    setTipologiaEdicao(tipologiaParaEditar)
    setDialogAberto(true)
  }

  const duplicarTipologiaHandler = (index: number) => {
    const tipologiaParaDuplicar = dadosTipologias[index]
    const novosDadosTipologia = dadosTipologias.concat(tipologiaParaDuplicar)

    setDadosTipologia(novosDadosTipologia)
    dadosTipologiaHandler(novosDadosTipologia)
  }

  return (
    <S.Wrapper>
      <S.NomeSecao>Tipologias</S.NomeSecao>
      <TableContainer component={S.BoxCustomizado}>
        <Table data-cy="tabelaTipologias">
          <TableHead>
            <TableCell align="center" style={{ lineHeight: theme.font.sizes.large }}>
              Descrição do Produto
            </TableCell>
            <TableCell align="center" style={{ lineHeight: theme.font.sizes.large }}>
              Quantidade de Unidades
            </TableCell>
            <TableCell align="center" style={{ lineHeight: theme.font.sizes.large }}>
              Quantidade de Permutas
            </TableCell>
            <TableCell align="center" style={{ lineHeight: theme.font.sizes.large }}>
              Área Lote (m²)
            </TableCell>
            <TableCell align="center" style={{ lineHeight: theme.font.sizes.large }}>
              Tipologia Casas
            </TableCell>
            <TableCell align="center" style={{ lineHeight: theme.font.sizes.large }}>
              Área Casa (m²)
            </TableCell>
            <TableCell align="center" style={{ lineHeight: theme.font.sizes.large }}>
              Perímetro de Muro por Lote (m)
            </TableCell>
            <TableCell align="center" style={{ lineHeight: theme.font.sizes.large }}>
              Área Serviço Ext. (m²)
            </TableCell>
            <TableCell align="center" style={{ lineHeight: theme.font.sizes.large }}>
              Preço Tabela (R$/Unid)
            </TableCell>
            <TableCell align="center"></TableCell>
          </TableHead>
          <TableBody>
            {dadosTipologias.map((tipologia: DadosTipologia, index: number) => (
              <TableRow key={`tipologia${index}`} data-cy={`trTipologias_${index}`}>
                <TableCell data-cy="tdDescricao" align="center">
                  {tipologia.descricao}
                </TableCell>
                <TableCell data-cy="tdQuantidadeUnidades" align="center">
                  {valorFormatado(tipologia.quantidadeUnidades, 0)}
                </TableCell>
                <TableCell data-cy="tdQuantidadePermutas" align="center">
                  {tipologia.quantidadePermutas == null ? '-' : valorFormatado(tipologia.quantidadePermutas, 0)}
                </TableCell>
                <TableCell data-cy="tdAreaLote" align="center">
                  {valorFormatado(tipologia.areaLote)}
                </TableCell>
                <TableCell data-cy="tdTipologiaCasas" align="center">
                  {tipologia.tipologiaCasas}
                </TableCell>
                <TableCell data-cy="tdTipologiaAreaCasa" align="center">
                  {valorFormatado(tipologia.areaCasa)}
                </TableCell>
                <TableCell data-cy="tdPerimetroMuroPorLote" align="center">
                  {tipologia.perimetroMuroPorLote == null ? '-' : valorFormatado(tipologia.perimetroMuroPorLote, 0)}
                </TableCell>
                <TableCell data-cy="tdAreaServico" align="center">
                  {tipologia.areaServicoExterna == null ? '-' : valorFormatado(tipologia.areaServicoExterna)}
                </TableCell>
                <TableCell data-cy="tdPrecoTabela" align="center">
                  {valorFormatado(tipologia.precoTabela)}
                </TableCell>
                <TableCell align="center">
                  <S.GridBotoes>
                    <div>
                      <IconButton
                        color="primary"
                        data-cy="btnEditarTipologia"
                        aria-label="delete"
                        onClick={() => {
                          editarTipologiaHandler(index)
                        }}
                      >
                        <Edit size={24} />
                      </IconButton>
                    </div>
                    <div>
                      <IconButton
                        color="primary"
                        data-cy="btnDuplicarTipologia"
                        aria-label="delete"
                        onClick={() => {
                          duplicarTipologiaHandler(index)
                        }}
                      >
                        <ContentCopy size={24} />
                      </IconButton>
                    </div>
                    <div>
                      <IconButton
                        color="primary"
                        data-cy="btnDeletarTipologia"
                        aria-label="delete"
                        onClick={() => {
                          deletarTipologiaHandler(index)
                        }}
                      >
                        <Delete size={24} />
                      </IconButton>
                    </div>
                  </S.GridBotoes>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <S.GridBotao>
        <Button data-cy="btnNovaTipologia" onClick={abrirDialog} variant="contained" style={{ height: '40px' }} color="secondary" startIcon={<Add size={24} />}>
          Nova Tipologia
        </Button>
      </S.GridBotao>
      <Dialog open={dialogAberto} maxWidth="lg" onClose={fecharDialog} aria-labelledby="simple-modal-title" aria-describedby="simple-modal-description">
        <NovaTipologia
          closeDialogTipologiaHandler={fecharDialog}
          adicionarTipologiaHandler={adicionarNovaTipologiaHandler}
          editarTipologiaHandler={editarTipologiaDialogHandler}
          dadosTipologia={tipologiaEdicao}
          indiceEdicao={indiceEdicao}
        ></NovaTipologia>
      </Dialog>
    </S.Wrapper>
  )
}

export default Tipologias
